export const dummyData = {
    projectName: "Vedic Lifestyle",

    // ✅ unchanged
    dummyProjects: [
        { label: "Vedic Lifestyle", value: "p1" }
    ],

    lastUpdated: "7:18 PM",
    date: "03 Feb 2026",

    weeklyStats: {
        planned: 50,
        done: 44,
        delayed: 6,
        completion: 88
    },

    stageColors: ["#1F4B55", "#E3C86F", "#7FA0A5", "#FF7676", "#1F4B55"],

    stages: [
        { name: "Foundation", plan: 100, actual: 100, color: "#1F4B55" },
        { name: "Structural", plan: 90, actual: 83, color: "#1F4B55" },
        { name: "MEP Rough- in", plan: 85, actual: 70, color: "#E3C86F" },
        { name: "Interior Walls", plan: 55, actual: 46, color: "#7FA0A5" },
        { name: "Finishes", plan: 40, actual: 24, color: "#E3C86F" },
        { name: "External Works", plan: 25, actual: 12, color: "#FF7676" },
        { name: "Landscaping", plan: 15, actual: 5, color: "#7FA0A5" },
        { name: "Painting", plan: 10, actual: 0, color: "#1F4B55" },
        { name: "Flooring", plan: 30, actual: 15, color: "#E3C86F" },
        { name: "Window Installation", plan: 60, actual: 50, color: "#1F4B55" },
        { name: "Door Installation", plan: 50, actual: 40, color: "#7FA0A5" },
        { name: "Electrical Wiring", plan: 70, actual: 60, color: "#E3C86F" },
        { name: "Plumbing Fixtures", plan: 45, actual: 30, color: "#FF7676" }
    ],

    topDelays: [
        {
            id: 1,
            title: "Electrical Panel Approval – Tower A",
            cause: "Vendor drawings pending revision",
            person: "Amit Verma",
            type: "Critical"
        },
        {
            id: 2,
            title: "Plastering Work – 7th Floor",
            cause: "Labour shortage",
            person: "Suresh Patil",
            type: "High"
        },
        {
            id: 3,
            title: "Concrete Pour – Parking Area",
            cause: "RMC truck arrival delay",
            person: "Neha Kapoor",
            type: "Medium"
        }
    ],

    materialSignals: [
        { name: "Cement", count: "410/500 Bags", status: "Normal" },
        { name: "Steel Rebar", count: "6/10 Tons", status: "Shortage" },
        { name: "Ready Mix Concrete", count: "96/100 m3", status: "Normal" },
        { name: "Sand", count: "52/40 Tons", status: "Excess" },
        { name: "Bricks", count: "14K/18K Units", status: "Low" },
        { name: "PVC Conduits", count: "9/15 Bundles", status: "Critical" }
    ],

    accountability: [
        {
            id: 1,
            role: "Site Engineer",
            name: "Rajesh Sharma",
            initials: "RS",
            tasksCompleted: 17,
            totalTasks: 19,
            percentage: 89,
            delayed: 2
        },
        {
            id: 2,
            role: "Project Manager",
            name: "Kavita Rao",
            initials: "KR",
            tasksCompleted: 21,
            totalTasks: 23,
            percentage: 91,
            delayed: 1
        },
        {
            id: 3,
            role: "MEP Supervisor",
            name: "Vikram Singh",
            initials: "VS",
            tasksCompleted: 12,
            totalTasks: 16,
            percentage: 75,
            delayed: 3
        },
        {
            id: 4,
            role: "Safety Officer",
            name: "Amit Patel",
            initials: "AP",
            tasksCompleted: 10,
            totalTasks: 10,
            percentage: 100,
            delayed: 0
        },
        {
            id: 5,
            role: "Quality Control",
            name: "Sneha Gupta",
            initials: "SG",
            tasksCompleted: 14,
            totalTasks: 15,
            percentage: 93,
            delayed: 1
        },
        {
            id: 6,
            role: "Surveyor",
            name: "Rahul Verma",
            initials: "RV",
            tasksCompleted: 8,
            totalTasks: 10,
            percentage: 80,
            delayed: 2
        },
        {
            id: 7,
            role: "Foreman",
            name: "Manoj Kumar",
            initials: "MK",
            tasksCompleted: 20,
            totalTasks: 25,
            percentage: 80,
            delayed: 5
        },
        {
            id: 8,
            role: "Architect",
            name: "Priya Desai",
            initials: "PD",
            tasksCompleted: 5,
            totalTasks: 5,
            percentage: 100,
            delayed: 0
        },
        {
            id: 9,
            role: "Civil Engineer",
            name: "Anil Mehta",
            initials: "AM",
            tasksCompleted: 18,
            totalTasks: 20,
            percentage: 90,
            delayed: 2
        },
        {
            id: 10,
            role: "Electrical Supervisor",
            name: "Suresh Reddy",
            initials: "SR",
            tasksCompleted: 15,
            totalTasks: 18,
            percentage: 83,
            delayed: 3
        },
        {
            id: 11,
            role: "Plumbing Supervisor",
            name: "Dinesh Karthik",
            initials: "DK",
            tasksCompleted: 12,
            totalTasks: 14,
            percentage: 85,
            delayed: 2
        },
        {
            id: 12,
            role: "Store Manager",
            name: "Rakesh Jhunjhunwala",
            initials: "RJ",
            tasksCompleted: 30,
            totalTasks: 30,
            percentage: 100,
            delayed: 0
        },
        {
            id: 13,
            role: "Safety Inspector",
            name: "Sunil Gavaskar",
            initials: "SG",
            tasksCompleted: 8,
            totalTasks: 8,
            percentage: 100,
            delayed: 0
        },
        {
            id: 14,
            role: "Lab Technician",
            name: "Virat Kohli",
            initials: "VK",
            tasksCompleted: 22,
            totalTasks: 25,
            percentage: 88,
            delayed: 3
        },
        {
            id: 15,
            role: "Site Supervisor",
            name: "Rohit Sharma",
            initials: "RS",
            tasksCompleted: 25,
            totalTasks: 28,
            percentage: 89,
            delayed: 3
        },
        {
            id: 16,
            role: "Junior Engineer",
            name: "Hardik Pandya",
            initials: "HP",
            tasksCompleted: 10,
            totalTasks: 12,
            percentage: 83,
            delayed: 2
        }
    ],

    nextWeekPlan: [
        { id: 1, title: "Complete MEP conduit laying – Tower B", tag: "MEP", tagType: "mep" },
        { id: 2, title: "Begin terrace waterproofing", tag: "Weather", tagType: "weather" },
        { id: 3, title: "Structural Inspection - Block C", tag: "Structural", tagType: "structural" },
        { id: 4, title: "Material Delivery for Flooring", tag: "Logistics", tagType: "logistics" },
        { id: 5, title: "Safety Awareness Workshop", tag: "Safety", tagType: "safety" },
        { id: 6, title: "Grid Ceiling Installation - Lobby", tag: "Interiors", tagType: "interiors" },
        { id: 7, title: "External Plastering - North Face", tag: "Civil", tagType: "civil" },
        { id: 8, title: "Plumbing Pressure Test", tag: "Plumbing", tagType: "plumbing" },
        { id: 9, title: "Client Site Visit", tag: "Management", tagType: "management" },
        { id: 10, title: "Pouring concrete for driveway", tag: "Civil", tagType: "civil" }
    ],

    // ✅ unchanged
    photoHighlights: [
        { id: 1, title: "Structural Slab Inspection", time: "Tue, 10:30 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0i0O2Huuz453uaVlncDVlrcCU9Atf4JhRWA&s" },
        { id: 2, title: "Phase 1 Earthworks", time: "Wed, 02:00 PM", url: "https://cdn.shopify.com/s/files/1/0567/3873/files/digging-a-hole-1692944_640_480x480.jpg?v=1602082689" },
        { id: 3, title: "Material Transport Logistics", time: "Fri, 04:30 PM", url: "https://img.freepik.com/premium-photo/dump-truck-with-raised-body-construction-site-transportation-unloading-sand-soil-technique-transportation-bulk-materials-transportation-bulk-building-materials_331695-8729.jpg" },
        { id: 4, title: "Foundation Pouring", time: "Mon, 09:15 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq-yXbHk3g8Z9Z2Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 5, title: "Rebar Installation", time: "Tue, 11:45 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1v4J7Q8X9X9X9X9X9X9X9X9X9X9X9X9X9Xw&s" },
        { id: 6, title: "Site Surveying", time: "Wed, 03:20 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" },
        { id: 7, title: "Excavation Work", time: "Thu, 08:30 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 8, title: "Bricklaying Phase 2", time: "Fri, 01:10 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" },
        { id: 9, title: "Pipeline Installation", time: "Sat, 10:00 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 10, title: "Electrical Wiring", time: "Mon, 02:45 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" },
        { id: 11, title: "Roofing Framework", time: "Tue, 04:15 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 12, title: "Safety Inspection", time: "Wed, 11:30 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" },
        { id: 13, title: "Material Unloading", time: "Thu, 09:50 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 14, title: "Concrete Mixing", time: "Fri, 03:00 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" },
        { id: 15, title: "Scaffolding Setup", time: "Sat, 08:30 AM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9g&s" },
        { id: 16, title: "Final Cleanup", time: "Sun, 05:00 PM", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-_8Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9Z9pw&s" }
    ],

    executionSummary: {
        progress: 84,
        summary:
            "Site performance improved today with strong structural progress and faster interior wall completion. Minor material and labour issues caused limited delays.",
        nextWeekFocus:
            "Focus on completing MEP rough-in, waterproofing works, and securing pending approvals. Ensure steel and PVC conduit stocks are replenished.",
        generatedAt: "Sunday, 16 Feb 2026 at 7:18 PM"
    }
};
